import { gql, useMutation } from "@apollo/client";

const DELETE_PLAYER_MUTATION = gql`
    mutation DeletePlayer($rosterId: Int!) {
        deletePlayer(rosterId: $rosterId) {
            success
        }
    }
`;

export default function DeletePlayerMutation() {
    return useMutation(DELETE_PLAYER_MUTATION);
}


